"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rgba = void 0;
/**
 * Simple opacity parser for rgba function.
 * @param {number} opacity – can be in the float range 0..1 or in the percentage range 2..100.
 * @returns {number | string} number in range 0..1 or string with percentage sign.
 */
const parseOpacity = (opacity) => opacity <= 1 && opacity >= 0 ? opacity : `${opacity}%`;
/**
 * rgba function to transform colours and specify opacity to them
 * @param {string} colour – colour in HEX format
 * @param {number} [opacity] – optional opacity param for a transformed colour
 * @returns {string} colour in rgba(255, 255, 255, 0.87) or rgba(255, 255, 255, 25%) format
 * @deprecated Use `color-mix` css function instead
 */
const rgba = (colour, opacity) => {
    // Validate input
    if (!colour.startsWith("#")) {
        throw new Error(`Incorrect param colour passed to rgba function: hex colour expected, but ${colour} provided`);
    }
    // Parse colour, it may already have an opacity channel
    // Channel can be coded with one or two characters:
    // #RGB (or #RGBA) and #RRGGBB (or #RRGGBBAA)
    const channelSize = colour.length <= 5 ? 1 : 2;
    let red = colour.substring(1, 1 + channelSize);
    let green = colour.substring(1 + channelSize, 1 + channelSize * 2);
    let blue = colour.substring(1 + channelSize * 2, 1 + channelSize * 3);
    let alpha = colour.substring(1 + channelSize * 3, 1 + channelSize * 4);
    // Double values for short hex format
    // #RGBA -> #RRGGBBAA
    if (channelSize === 1) {
        red = `${red}${red}`;
        green = `${green}${green}`;
        blue = `${blue}${blue}`;
        alpha = `${alpha}${alpha}`;
    }
    // Convert channels
    const channels = [
        parseInt(red, 16),
        parseInt(green, 16),
        parseInt(blue, 16),
    ];
    // Opacity can be provided, parsed or missed at all (using default for that case)
    if (opacity) {
        channels.push(parseOpacity(opacity));
    }
    else if (alpha.length) {
        channels.push(Math.round((parseInt(alpha, 16) * 100) / 255) / 100);
    }
    else {
        channels.push(1);
    }
    // Wrap it all together in a template
    return `rgba(${channels.join(", ")})`;
};
exports.rgba = rgba;
//# sourceMappingURL=rgba.js.map